<template>
    <NxSelect
    :value="localValue"
    :options="listOptions"
    labelText="Motivo de Perda:"
    id="selectReasonLoss"
    placeholder="Selecione o Motivo"
    :multiple="false"
    @update:value="handleValueUpdate"
  ></NxSelect>
</template>
<script>
import { toast } from '@/shared/utils/UIHelper'
import { useReactiveModelMixin } from '../../mixins'
import ReasonLossRepository from '@/shared/http/repositories/configurations/reason.js'

export default {
  name: 'NxSelectMotivoPerda',
  mixins: [ useReactiveModelMixin('value') ],
  data () {
    return {
      listOptions: [],
      selected: null
    }
  },
  created () {
    this.onLoadReasonLoss()
  },
  methods: {
    onLoadReasonLoss () {
      ReasonLossRepository.GetAllSituacaoActive('PERDIDO')
        .then((response) => {
          let result = response.data.content
            .map((x) => ({'value': x.id, 'text': x.nome}))
          this.listOptions = result
        })
        .catch((err) => {
          toast.error('Não foi possível carregar a lista de motivos de perda', 'Erro')
          console.error(err)
        })
    },
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectMotivoPerda.vue